export default {"src":"/_next/static/media/last.6777929a.svg","height":36,"width":56,"blurWidth":0,"blurHeight":0};